import { TicketFile } from 'lib/api/ticket-files/ticket-files'
import { AdminTicketFile } from 'lib/api/admin/ticket-files/admin-ticket-files'

// Returns Bytescale-CDN provided, S3-backed, preview image URL if the feature flag is enabled + is available, otherwise returns default preview URL
export function useS3PreviewImage(ticketFile?: Pick<TicketFile, 'previewUrl'> | Pick<AdminTicketFile, 'previewUrl'>) {
  return ticketFile?.previewUrl
}
